/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft resembles Excel, but a familiar toolbar does not establish feature parity. This comparison uses the v0.7.0 build available on this site and separates Excel for the web from Excel desktop. Feature availability can vary by Excel plan, platform and release.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 的界面与 Excel 相似，但熟悉的工具栏并不代表功能完全一致。本指南以本站提供的 v0.7.0 为基础，并区分 Excel 网页版与桌面版。Excel 功能可能因方案、平台和版本而有所不同。`)
};

/**
* | output |
* | --- |
* | "GridCraft resembles Excel, but a familiar toolbar does not establish feature parity. This comparison uses the v0.7.0 build available on this site and separat..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_paragraphs_0 as "gc.search_guides.gridcraft_vs_excel.sections.0.paragraphs.0" }